<template>
    <div class="rail-panel">
        <div class="rail-panel__head">
            <span class="rail-panel__title">Crédito</span>
            <span class="rail-panel__subject">{{ creditClient?.nombreComercial || '' }}</span>
        </div>
        <table class="rail-table">
            <tbody>
                <tr>
                    <td>Días de crédito</td>
                    <td>{{ creditClient.diasCredito }}</td>
                </tr>
                <tr>
                    <td>Documento permitido</td>
                    <td>{{ creditClient.documentoCredito }}</td>
                </tr>
                <tr>
                    <td>Límite de crédito</td>
                    <td>{{ creditClient.limiteCreditoNatural }}</td>
                </tr>
                <tr class="red--text text--darken-4">
                    <td>Documentos pendientes</td>
                    <td>{{ creditClient.numberDocument }}</td>
                </tr>
                <tr class="red--text text--darken-4">
                    <td>Ventas pendientes</td>
                    <td>{{ creditClient.debtNatural }}</td>
                </tr>
                <tr class="rail-table__row--balance">
                    <td>Saldo disponible</td>
                    <td>{{ creditClient.balanceNatural }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
/**
 * Detalle del crédito de un cliente.
 *
 * Es un componente de PRESENTACIÓN: recibe los datos ya cargados y no pide
 * nada. Quien carga es la vista que lo usa, porque el dato también se
 * necesita para validar la venta a crédito — si el componente fuera el único
 * en pedirlo, el saldo no estaría disponible hasta que el panel se abriera.
 */
export default {
    name: 'DetailCreditClient',
    props: {
        creditClient: { type: Object, default: () => ({}) }
    }
}
</script>
